import { BaseButtonWidgetRenderer } from './base-button-widget-renderer';
import { SubmitWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';
import { normalizeSubmitVariant } from '../../utils/nav-direction.utils';

export class SubmitWidgetRenderer extends BaseButtonWidgetRenderer<SubmitWidgetJsonData> {
    protected override get defaultData(): SubmitWidgetJsonData {
        return {
            id: '',
            type: 'submit',
            variant: 'simple',
            submitLabel: TranslateUtils.SUBMIT_WIDGET.LABEL,
            previousLabel: TranslateUtils.SUBMIT_WIDGET.PREVIOUS_LABEL,
            nextLabel: TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL,
            height: SubmitWidgetRenderer.defaultButtonHeight
        };
    }

    public override createNew(options?: WidgetRenderOptions & { isExtendedVariant?: boolean }): HTMLElement {
        const defaultData = super.createDefaultData();

        if (options?.isExtendedVariant) {
            defaultData.variant = 'extended';
        }

        return this.render(defaultData, options);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: SubmitWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const isExtended = normalizeSubmitVariant(widgetJsonData.variant) === 'extended';
        if (isExtended) {
            if (widgetJsonData.previousLabel !== null && widgetJsonData.previousLabel !== undefined) {
                const prevButton = this.createButton('previous', widgetJsonData.previousLabel || TranslateUtils.SUBMIT_WIDGET.PREVIOUS_LABEL);
                content.appendChild(prevButton);
            }

            if (widgetJsonData.nextLabel !== null && widgetJsonData.nextLabel !== undefined) {
                const nextButton = this.createButton('next', widgetJsonData.nextLabel || TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL);
                content.appendChild(nextButton);
            }

            if (widgetJsonData.submitLabel !== null && widgetJsonData.submitLabel !== undefined) {
                const submitButton = this.createButton('submit', widgetJsonData.submitLabel || TranslateUtils.SUBMIT_WIDGET.LABEL, 'submit');
                content.appendChild(submitButton);
            }
        } else {
            // null submitLabel = "hidden by page position" (serve-time prepare nulls the label
            // on first/middle pages of nav-button format forms) — render no button, same
            // null-guards as the extended branch above. Legacy snapshots are unaffected:
            // their Simple serves always carry a non-null label (defaultData is non-null too,
            // so the editor canvas keeps rendering the button).
            if (widgetJsonData.submitLabel !== null && widgetJsonData.submitLabel !== undefined) {
                const submitButton = this.createButton('submit', widgetJsonData.submitLabel || TranslateUtils.SUBMIT_WIDGET.LABEL, 'submit');
                content.appendChild(submitButton);
            }
        }

        return content;
    }

    protected override applyAdditionalAttributes(element: HTMLElement, widgetJsonData: SubmitWidgetJsonData): void {
        super.applyAdditionalAttributes(element, widgetJsonData);

        if (normalizeSubmitVariant(widgetJsonData.variant) === 'extended') {
            element.dataset['variant'] = 'extended';
        }

        this.applyButtonElementAttributes(element, widgetJsonData.height);
    }
}
